/**
 * ETL backend URLs.
 *
 * Browser requests use same-origin `/api` (Netlify proxy in prod, CRA proxy in dev)
 * so the browser never hits Cloud Run cross-origin CORS.
 *
 * WebSockets still connect directly to Cloud Run — requires public invoker on the service.
 */
const remoteBackend = (
  process.env.REACT_APP_ETL_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  'https://etl-backend-7ampm726qa-uc.a.run.app'
).replace(/\/$/, '');

const useDevProxy =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ETL_USE_PROXY !== 'false';

/** Same-origin /api in the browser (proxied). Full URL only for non-browser / tooling. */
const useSameOriginApi =
  typeof window !== 'undefined' &&
  (useDevProxy || process.env.REACT_APP_ETL_USE_PROXY !== 'false');

export const ETL_BACKEND_URL = useSameOriginApi ? '' : remoteBackend;

export const ETL_API = useSameOriginApi ? '/api' : `${remoteBackend}/api`;

/** WebSocket base — in dev with local ETL, connect direct to uvicorn (CRA WS proxy is unreliable). */
export function getEtlWsBase() {
  const localDev = process.env.REACT_APP_ETL_DEV_BACKEND;
  if (typeof window !== 'undefined' && useDevProxy && localDev) {
    return localDev.replace(/^https?:/, window.location.protocol === 'https:' ? 'wss:' : 'ws:');
  }
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    if (useSameOriginApi) {
      return `${protocol}//${window.location.host}`;
    }
    if (useDevProxy) {
      return `${protocol}//${window.location.host}`;
    }
  }
  return remoteBackend.replace(/^https?/, 'ws');
}

export { remoteBackend as ETL_REMOTE_BACKEND };
